<template>
  <div class="settings_component">
    <label :for="'setting_' + name">{{ label }}</label>
    <div v-if="type === 'text'">
        <input
        type="text"
        :id="'setting_' + name"
        :placeholder="placeholder || ''"
        :required="required"
        :name="'setting_' + name"
        :value="value"
        />
    </div>
    <div v-if="type === 'oauth'" style="width:100%;">
        <button type="button" @click="startOAuth" style="margin-left:auto;margin-right:auto;">
            {{ oAuthButtonText }}
        </button>
        <input type="hidden" :name="'setting_' + name" :value="oauth_data">
    </div>
  </div>
</template>

<script>
import Config from "../config";
import { storage } from "../schmucklicloud";

export default {
    props: {
        name: {
            type: String,
            required: true
        },
        tile_path: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: "text"
        },
        label: {
            type: String,
            required: true
        }, 
        placeholder: {
            type: String,
            required: false
        },
        required: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            required: false
        },
        oauth_settings: {
            type: Object,
            required: false,
            default: () => {}
        }
    },
    data() {
        return {
            oauth_result: undefined,
            oauth_data: undefined
        }
    },
    computed: {
        oAuthButtonText(){
            if (this.oauth_data === undefined) {
                return "Link now";
            } else {
                return "Linked";
            }
        }
    },
    mounted() {
        if (this.value !== undefined && this.type === "oauth") {
            this.oauth_data = this.value;
        }
    },
    methods: {
        startOAuth() {
            var state = this.getUUID() + "___" + this.name;
            storage.insert("temp_settings_oauth", {
                state: state,
                path: this.tile_path
            }).then(function(response) {
                if (response.isOK) {
                    localStorage.removeItem("current_oauth_request");

                    var additional_parameters = this.serialize(this.oauth_settings.additional_parameters);

                    window.oauth_dialog = window.open(this.oauth_settings.code_url + 
                    "?client_id="+ this.oauth_settings.client_id +
                    "&scope=" + this.oauth_settings.scope.join(this.oauth_settings.scope_delimiter || ",") +
                    "&response_type=code" +
                    "&state=" + state +
                    "&redirect_uri=" + Config.DEFAULT_OAUTH_SETTINGS_REDIRECT_URI +
                    "&" + additional_parameters,
                    "oauth_dialog",
                    'height=700,width=550');

                    var hasWindowClosed = setInterval(function() {
                        this.oauth_result = JSON.parse(localStorage.getItem("current_oauth_request"));
                        if(this.oauth_result !== null) {
                            localStorage.removeItem("current_oauth_request");
                            clearInterval(hasWindowClosed);
                        }
                    }.bind(this), 200);
                }
            }.bind(this));
        },
        getUUID() {
            return Math.random().toString(36).substr(2, 9);
        },
        serialize(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        }
    },
    watch: {
        oauth_result() {
            this.oauth_data = JSON.stringify(this.oauth_result.data);
        }
    }
};
</script>

<style>
.settings_component {
    margin-top: 10px;
}
</style>